// components/Common/NotificationSnackbar.tsx
import React from 'react';
import { Snackbar, Alert } from '@mui/material';
import { NotificationState } from '../../types';

interface NotificationSnackbarProps {
  notification: NotificationState;
  onClose: () => void;
}

const NotificationSnackbar: React.FC<NotificationSnackbarProps> = ({
  notification,
  onClose,
}) => {
  return (
    <Snackbar
      open={notification.open}
      autoHideDuration={6000}
      onClose={onClose}
    >
      <Alert 
        severity={notification.severity} 
        onClose={onClose}
        sx={{ width: '100%' }}
      >
        {notification.message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSnackbar;